import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    setFirstName: ['firstName'],
    resetAccount: null,
    setEmployeeId: ['employeeId'],
    setPermissions: ['permissions']
})

export const AccountDataTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    firstName: '',
    employeeId: null,
    permissions: []
})

/* ------------- Reducers ------------- */
export const registerSetFirstName = (state, { firstName }) =>
    state.merge({ firstName: firstName })

export const registerSetEmployeeId = (state, { employeeId }) => {
    if (employeeId && typeof window.heap?.identify === 'function') {
        window.heap.identify(employeeId);
    }
    return state.merge({ employeeId: employeeId })
}

export const registerSetPermissions = (state, { permissions }) =>
    state.merge({ permissions: permissions })

export const registerResetAccount = (state) => INITIAL_STATE

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_FIRST_NAME]: registerSetFirstName,
    [Types.SET_EMPLOYEE_ID]: registerSetEmployeeId,
    [Types.SET_PERMISSIONS]: registerSetPermissions,
    [Types.RESET_ACCOUNT]: registerResetAccount
})